import {float} from '../../../utils/types';
import Language from '../../../language';
import ImageUtil from '../../../utils/image';


export default ({user}) => (
    <div className="user">
        <div className="avatar">
            <ImageUtil
                path={`/avatars/${user.avatar}.png`} 
                alt={Language('layers.main.bottom.avatar')} />
        </div>

        <div className="balance">
            <span>{Language('layers.main.bottom.balance', {balance:float(user.balance)})}</span>
        </div>
    </div>
)